import { styled } from 'styletron-react';

export const CenteredSubContent = styled('div', {
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  paddingTop: '8px',
  paddingBottom: '8px'
});
